import '../../themes/global.scss';
import '../../themes/job_summary.scss';
import '../../themes/payment.scss';

import { useEffect, useState } from 'react';
import { Alert, Column, Row, Spinner, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useDispatch, useSelector } from 'react-redux';
import { OutlineArrowLeftIcon, OutlineLockClosedIcon } from '@tempmee/react-icons';

import {
  DELETE_DEFAULT_PAYMENT_ACTION,
  DELETE_PAYMENT_ACTION,
  GET_ALL_PAYMENTS_ACTION,
  SELECT_PAYMENT_ACTION,
  getAllPaymnets,
} from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import { useCheckPaymentExpiration } from '../Inbox/Notification/Reminders/hooks/useCheckPaymentExpiration';
import { BankList } from './components/BankList';
import { CardList } from './components/CardList';
import { SuspendedPostingsPopup } from './SuspendedPostingsPopup';

const outerWrapperStyle = { width: '100%', margin: '20px 10px' };
const contentAreaStyle = {
  backgroundColor: colors.neutral[50],
  paddingTop: 56,
  paddingBottom: 56,
  marginTop: 40,
  minHeight: 400,
};
const officeBarStyle = {
  backgroundColor: colors.neutral[100],
  height: 52,
  marginBottom: 4,
};
const backButtonResetStyle = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
};

const loadingSelector = createLoadingSelector([
  GET_ALL_PAYMENTS_ACTION,
  SELECT_PAYMENT_ACTION,
  DELETE_PAYMENT_ACTION,
  DELETE_DEFAULT_PAYMENT_ACTION,
]);

export default function Payment() {
  const dispatch = useDispatch();
  const [selectedPayment, setSelectedPayment] = useState(null);
  const isLoading = useSelector((state) => loadingSelector(state));
  const selectedChildOffice = useSelector((state) => state.user.selectedChildOffice);
  const childOffices = useSelector((state) => state.user.childOffices);

  const { isExpired, isExpiring } = useCheckPaymentExpiration();

  useEffect(() => {
    dispatch(getAllPaymnets());
  }, [dispatch]);

  return (
    <div className="component_container">
      <div className="floating_container" style={{ justifyContent: 'flex-start' }}>
        <div style={outerWrapperStyle}>
          <button type="button" style={backButtonResetStyle} onClick={() => history.back()}>
            <Row align="center" gap={2}>
              <OutlineArrowLeftIcon color={colors.secondary[500]} />
              <Typography size="heading_4" bold color={colors.secondary[500]}>
                Back
              </Typography>
            </Row>
          </button>

          <Column align="center" gap={10} style={{ width: '100%' }}>
            <Typography size="heading_2" bold color={colors.neutral[600]}>
              Payment Information
            </Typography>

            <Row align="center" justify="start" gap={1}>
              <Typography italic color={colors.neutral[500]}>
                GoTu works with Stripe &amp; Plaid to secure your payment information.
              </Typography>
              <OutlineLockClosedIcon color={colors.neutral[500]} />
            </Row>
          </Column>

          <Column gap={3} px={8} style={contentAreaStyle}>
            {isExpired && (
              <Alert
                variant="hard-warning"
                description="Your default payment method has expired. Please update your payment method to confirm future professionals."
              />
            )}

            {isExpiring && (
              <Alert
                variant="soft-warning"
                description="Your default payment method is about to expire. Please update your payment method to confirm future professionals."
              />
            )}

            {childOffices.length > 1 && (
              <Row align="center" pl={8} style={officeBarStyle}>
                <Typography size="body_large" bold color={colors.neutral[600]}>
                  Office Name:{' '}
                  <Typography as="span" size="body_large" color={colors.neutral[600]}>
                    {selectedChildOffice?.office_name}
                  </Typography>
                </Typography>
              </Row>
            )}

            {isLoading && (
              <Row align="center" justify="center" style={{ width: '100%', flex: 1, minHeight: 300 }}>
                <Spinner />
              </Row>
            )}

            {!isLoading && (
              <>
                <CardList
                  selectedPayment={selectedPayment}
                  setSelectedPayment={setSelectedPayment}
                />
                <BankList
                  selectedPayment={selectedPayment}
                  setSelectedPayment={setSelectedPayment}
                />
              </>
            )}
          </Column>
        </div>
      </div>
      <SuspendedPostingsPopup />
    </div>
  );
}
